<script>
	import { onMount, createEventDispatcher } from 'svelte';
	import { fade } from 'svelte/transition';
    import Identity from 'svelte-key'
    import Node from './Node.svelte';
    import { fetchData, getLocalServer } from '../utils/Data.svelte';
	import { sortById, groupSort, ignoreCaseSort, sortByName } from '../utils/Sort.svelte';
    import { addCircleOutline, arrowUp, grid, trash, link, bookmark, image, refresh, headset, videocam, document, map, cube, download, informationCircleOutline } from 'ionicons/icons/index.mjs';

    export let keys;
    export let isPublic;
    export let config;
    export let mapId;
    export let settings;
    export let tooltips;
    let state = {
        media: {},
        scene: {}
    }
    let pending = [];

    onMount(() => {
        if (window.platform == "Android" && window.apiVersion >= 4) {
            pending = androidAdapter.listMedia();
            if (pending) {
                pending = pending.split(",");
            }
        }
    })
    
    const dispatch = createEventDispatcher();

    function sendMessage(message) {
		dispatch('message', message);
    }

    function openHandler(type, section) {
        state[type][section] = !state[type][section]
    }
</script>

<div in:fade>
    {#if pending && pending.length > 0}
        <div class="tile tile-centered pl-2">
            <div class="tile-content">
                <div class="divider" data-content="PENDING MEDIA"></div>
            </div>
            <div class="tile-action">
                <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Upload Media" on:click={(e) => {
                        e.currentTarget.blur();
                        androidAdapter.processMedia();
                        dispatch('message', {
                            type: "toast",
                            data: {
                                message: "Uploading media..."
                            }
                        });
                        setTimeout(function () {
                            pending = androidAdapter.listMedia();
                            if (pending) {
                                pending = pending.split(",");
                            }
                        }, 5000);
                    }}>
                    <i class="svg">{@html arrowUp.md}</i>
                </button>
            </div>
        </div>
        <ul class="menu menu-nav">
            {#each pending as item}
                <div class="tile tile-centered">
                    <div class="tile-content tile-tree">
                        <li class="menu-item">{item}</li>
                    </div>
                </div>
            {/each}
        </ul>
    {/if}
	{#if config && config.project != "global"}
        <div class="tile tile-centered pl-2">
            <div class="tile-content">
                <div class="divider" data-content="PROJECT MEDIA"></div>
            </div>
            <div class="tile-action">
                {#if config.role > 1}
                    <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Add Media" on:click={(e) => {
                        e.currentTarget.blur();
                            sendMessage({
                                type: "modal",
                                data: {
                                    view: "mediaUpload",
                                    id: config.project,
                                    role: config.role
                                }
                            })
                        }}>
                        <i class="svg">{@html addCircleOutline.md}</i>
                    </button>
                {/if}
            </div>
        </div>
        <Identity key={keys.project}>
            {#if config}
                {#if Object.keys(config.media.project).length > 0}
                    {#if Object.keys(config.media.project).length == 1}
                        {#each Object.keys(config.media.project) as section}
                            <ul class="menu menu-nav">
                                {#if Object.values(config.media.project[section]).length > 0}
                                    {#each Object.values(config.media.project[section]).sort(sortByName) as item}
                                        <div class="tile tile-centered">
                                            <div class="tile-icon">
                                                <div class="type-icon">
                                                    {#if item.type == "link"}
                                                        <i class="svg">{@html link.md}</i>
                                                    {:else if item.type == "download"}
                                                        <i class="svg">{@html download.md}</i>
                                                    {:else if item.type == "pdf" || item.type == "document"}
                                                        <i class="svg">{@html bookmark.md}</i>
                                                    {:else if item.type == "image"}
                                                        <i class="svg">{@html image.md}</i>
                                                    {:else if item.type == "360"}
                                                        <i class="svg">{@html refresh.md}</i>
                                                    {:else if item.type == "audio"}
                                                        <i class="svg">{@html headset.md}</i>
                                                    {:else if item.type == "video"}
                                                        <i class="svg">{@html videocam.md}</i>
                                                    {:else}
                                                        <i class="svg">{@html document.md}</i>
                                                    {/if}
                                                </div>
                                            </div>
                                            <div class="tile-content">
                                                <li class="menu-item">
                                                    {#if settings.newTab && (item.type == "link" || item.type == "pdf")}
                                                        <a class="btn btn-link" target="_blank" href={item.uri}>{item.name}</a>
                                                    {:else if item.type == "download"}
													    {#if window.platform == "Windows"}
                                                            <button class="btn btn-link" on:click|stopPropagation={async (e) => {
                                                                e.currentTarget.blur();
                                                                let [res, err]  = await fetchData(getLocalServer() + "/core", {
                                                                    method: "POST",
                                                                    headers: {
                                                                            'Accept': 'application/json',
                                                                            'Content-Type': 'application/json'
                                                                    },
                                                                    body: JSON.stringify({
                                                                        url: item.uri
                                                                    })
                                                                });
                                                                if (err || !res.found) {
                                                                        window.open(item.uri, "_blank");
                                                                }
                                                            }}>
                                                            {item.name}
                                                            </button>
                                                        {:else}
                                                            <a class="btn btn-link" target="_blank" href={item.uri}>{item.name}</a>
                                                        {/if}
                                                    {:else}
                                                        <button class="btn btn-link"
                                                        on:click|stopPropagation={(e) => {
                                                            e.currentTarget.blur();
                                                            sendMessage({
                                                                type: "modal",
                                                                data: {
                                                                    view: "mediaView",
                                                                    media: item
                                                                }
                                                            })
                                                        }}>{item.name}</button>
                                                    {/if}
                                                </li>
                                                {#if item.description != ""}
                                                    <small class="tile-title">{item.description}</small>
                                                {/if}
                                            </div>
                                            <div class="tile-action">
                                                <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Details" on:click|stopPropagation={(e) => {
                                                            e.currentTarget.blur();
                                                            sendMessage({
                                                                type: "modal",
                                                                data: {
                                                                    view: "mediaUpload",
                                                                    id: config.project,
                                                                    group: section,
                                                                    media: item,
                                                                    role: config.role
                                                                }
                                                            })
                                                        }}>
                                                        <i class="svg">{@html informationCircleOutline.md}</i>
                                                </button>
                                            </div>
                                        </div>
                                    {/each}
                                {/if}
                            </ul>
                        {/each}
                    {:else}
                        {#each Object.keys(config.media.project).sort(ignoreCaseSort) as section}
                            <div class="accordion" in:fade>
                                {#if state.media[section]}
                                    <input type="checkbox" id={section + "-media"} on:change={(e) => {openHandler("media", section)}} name="accordion-checkbox" hidden checked>
                                {:else}
                                    <input type="checkbox" id={section + "-media"} on:change={(e) => {openHandler("media", section)}} name="accordion-checkbox" hidden>
                                {/if}
                                <label class="accordion-header" for={section + "-media"}>
                                    <div class="tile tile-centered">
                                        <div class="tile-icon">
                                            <div class="example-tile-icon">
                                                {#if state.media[section]}
                                                    <i class="icon icon-arrow-down centered"></i>
                                                {:else}
                                                    <i class="icon icon-arrow-right centered"></i>
                                                {/if}
                                            </div>
                                        </div>
                                        <div class="tile-content">
                                            <div class="tile-title">{section}</div>
                                        </div>
                                    </div>    
                                </label>
                                <div class="accordion-body">
                                    <ul class="menu menu-nav">
                                        {#if Object.values(config.media.project[section]).length > 0}
                                            {#each Object.values(config.media.project[section]).sort(sortByName) as item}
                                                <div class="tile tile-centered">
                                                    <div class="tile-icon">
                                                        <div class="type-icon">
                                                            {#if item.type == "link"}
                                                                <i class="svg">{@html link.md}</i>
                                                            {:else if item.type == "download"}
                                                                <i class="svg">{@html download.md}</i>
                                                            {:else if item.type == "pdf" || item.type == "document"}
                                                                <i class="svg">{@html bookmark.md}</i>
                                                            {:else if item.type == "image"}
                                                                <i class="svg">{@html image.md}</i>
                                                            {:else if item.type == "360"}
                                                                <i class="svg">{@html refresh.md}</i>
                                                            {:else if item.type == "audio"}
                                                                <i class="svg">{@html headset.md}</i>
                                                            {:else if item.type == "video"}
                                                                <i class="svg">{@html videocam.md}</i>
                                                            {:else}
                                                                <i class="svg">{@html document.md}</i>
                                                            {/if}
                                                        </div>
                                                    </div>
                                                    <div class="tile-content">
                                                        <li class="menu-item">
                                                            {#if settings.newTab && (item.type == "link" || item.type == "pdf")}
                                                                <a class="btn btn-link" target="_blank" href={item.uri}>{item.name}</a>
                                                            {:else if item.type == "download"}
													            {#if window.platform == "Windows"}
																	<button class="btn btn-link" on:click|stopPropagation={async (e) => {
																		e.currentTarget.blur();
																		let [res, err]  = await fetchData(getLocalServer() + "/core", {
																			method: "POST",
																			headers: {
																					'Accept': 'application/json',
																					'Content-Type': 'application/json'
																			},
																			body: JSON.stringify({
																				url: item.uri
																			})
																		});
																		if (err || !res.found) {
																				window.open(item.uri, "_blank");
																		}
																	}}>
																	{item.name}
																	</button>
																{:else}
																	<a class="btn btn-link" target="_blank" href={item.uri}>{item.name}</a>
																{/if}
                                                            {:else}
                                                                <button class="btn btn-link"
                                                                on:click|stopPropagation={(e) => {
                                                                    e.currentTarget.blur();
                                                                    sendMessage({
                                                                        type: "modal",
                                                                        data: {
                                                                            view: "mediaView",
                                                                            media: item
                                                                        }
                                                                    })
                                                                }}>{item.name}</button>
                                                            {/if}
                                                        </li>
                                                        {#if item.description != ""}
                                                            <small class="tile-title">{item.description}</small>
                                                        {/if}
                                                    </div>
                                                    <div class="tile-action">
                                                        <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Details" on:click|stopPropagation={(e) => {
                                                                    e.currentTarget.blur();
                                                                    sendMessage({
                                                                        type: "modal",
                                                                        data: {
                                                                            view: "mediaUpload",
                                                                            id: config.project,
                                                                            group: section,
                                                                            media: item,
                                                                            role: config.role
                                                                        }
                                                                    })
                                                                }}>
                                                                <i class="svg">{@html informationCircleOutline.md}</i>
                                                        </button>
                                                    </div>
                                                </div>
                                            {/each}
                                        {/if}
                                    </ul>
                                </div>
                            </div>
                        {/each}
                    {/if}
                {/if}
            {/if}
        </Identity>
    {/if}
    <div class="tile tile-centered pl-2">
        <div class="tile-content">
            <div class="divider" data-content="MAP MEDIA"></div>
        </div>
        <div class="tile-action">
            {#if config.role > 1}
                <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Add Media" on:click={(e) => {
                        e.currentTarget.blur();
                        sendMessage({
                            type: "modal",
                            data: {
                                view: "mediaUpload",
                                id: config.media_id,
                                role: config.role
                            }
                        })
                    }}>
                    <i class="svg">{@html addCircleOutline.md}</i>
                </button>
            {/if}
        </div>
    </div>
    <Identity key={keys.project}>
        {#if config}
            {#if Object.keys(config.media.scene).length > 0}
                {#each Object.keys(config.media.scene).sort(ignoreCaseSort) as section}
                    <div class="accordion" in:fade>
                        {#if state.scene[section]}
                            <input type="checkbox" id={section + "-scene"} on:change={(e) => {openHandler("scene", section)}} name="accordion-checkbox" hidden checked>
                        {:else}
                            <input type="checkbox" id={section + "-scene"} on:change={(e) => {openHandler("scene", section)}} name="accordion-checkbox" hidden>
                        {/if}
                        <label class="accordion-header" for={section + "-scene"}>
                            <div class="tile tile-centered">
                                <div class="tile-icon">
                                    <div class="example-tile-icon">
                                        {#if state.media[section]}
                                            <i class="icon icon-arrow-down centered"></i>
                                        {:else}
                                            <i class="icon icon-arrow-right centered"></i>
                                        {/if}
                                    </div>
                                </div>
                                <div class="tile-content">
                                    <div class="tile-title">{section}</div>
                                </div>
                            </div>    
                        </label>
                        <div class="accordion-body">
                            <ul class="menu menu-nav">
                                {#if Object.values(config.media.scene[section]).length > 0}
                                    {#each Object.values(config.media.scene[section]).sort(sortByName) as item}
                                        <div class="tile tile-centered">
                                            <div class="tile-icon">
                                                <div class="type-icon">
                                                    {#if item.type == "link"}
                                                        <i class="svg">{@html link.md}</i>
                                                    {:else if item.type == "download"}
                                                        <i class="svg">{@html download.md}</i>
                                                    {:else if item.type == "pdf" || item.type == "document"}
                                                        <i class="svg">{@html bookmark.md}</i>
                                                    {:else if item.type == "image"}
                                                        <i class="svg">{@html image.md}</i>
                                                    {:else if item.type == "360"}
                                                        <i class="svg">{@html refresh.md}</i>
                                                    {:else if item.type == "audio"}
                                                        <i class="svg">{@html headset.md}</i>
                                                    {:else if item.type == "video"}
                                                        <i class="svg">{@html videocam.md}</i>
                                                    {:else}
                                                        <i class="svg">{@html document.md}</i>
                                                    {/if}
                                                </div>
                                            </div>
                                            <div class="tile-content">
                                                <li class="menu-item">
                                                    {#if settings.newTab && (item.type == "link" || item.type == "pdf")}
                                                        <a class="btn btn-link" target="_blank" href={item.uri}>{item.name}</a>
                                                    {:else if item.type == "download"}
													    {#if window.platform == "Windows"}
                                                            <button class="btn btn-link" on:click|stopPropagation={async (e) => {
                                                                e.currentTarget.blur();
                                                                let [res, err]  = await fetchData(getLocalServer() + "/core", {
                                                                    method: "POST",
                                                                    headers: {
                                                                            'Accept': 'application/json',
                                                                            'Content-Type': 'application/json'
                                                                    },
                                                                    body: JSON.stringify({
                                                                        url: item.uri
                                                                    })
                                                                });
                                                                if (err || !res.found) {
                                                                        window.open(item.uri, "_blank");
                                                                }
                                                            }}>
                                                            {item.name}
                                                            </button>
                                                        {:else}
                                                            <a class="btn btn-link" target="_blank" href={item.uri}>{item.name}</a>
                                                        {/if}
                                                    {:else}
                                                        <button class="btn btn-link"
                                                        on:click|stopPropagation={(e) => {
                                                            e.currentTarget.blur();
                                                            sendMessage({
                                                                type: "modal",
                                                                data: {
                                                                    view: "mediaView",
                                                                    media: item
                                                                }
                                                            })
                                                        }}>{item.name}</button>
                                                    {/if}
                                                </li>
                                            </div>
                                            <div class="tile-action">
                                                <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Details" on:click|stopPropagation={(e) => {
                                                        e.currentTarget.blur();
                                                        sendMessage({
                                                            type: "modal",
                                                            data: {
                                                                view: "mediaUpload",
                                                                id: config.media_id,
                                                                group: section,
                                                                media: item
                                                            }
                                                        })
                                                    }}>
                                                    <i class="svg">{@html informationCircleOutline.md}</i>
                                                </button>
                                            </div>
                                        </div>
                                    {/each}
                                {/if}
                            </ul>
                        </div>
                    </div>
                {/each}
            {/if}
        {/if}
    </Identity>
    <div class="tile tile-centered pr-2 pl-2">
        <div class="tile-content">
            <div class="divider" data-content="PROJECT TREE"></div>
        </div>
    </div>
    <Identity key={keys.tree}>
        {#if config}
            {#if Object.keys(config.tree).length > 0}
                {#each Object.keys(config.tree) as section}
                    {#if section != "tables"}
                        {#if config.tree[section].child_count == 0}
                            <ul class="menu menu-nav">
                                <div class="tile tile-centered">
                                    <div class="tile-content tile-tree">
                                        <li class="menu-item {mapId == config.tree[section].id ? "active" : ""}">{config.tree[section].name}</li>
                                    </div>
                                    <div class="tile-action">
                                        {#if config.tree[section].type == "map"}
                                            <a href={isPublic ? "/maps/" + config.tree[section].id + "?public" : "/maps/" + config.tree[section].id} class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="View Map">
                                                <i class="svg">{@html map.md}</i>
                                            </a>
                                        {:else if config.tree[section].type == "scene"}
                                            <a href={isPublic ? "/scenes/" + config.tree[section].id + "?public" : "/scenes/" + config.tree[section].id} class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="View Scene">
                                                <i class="svg">{@html cube.md}</i>
                                            </a>
                                        {:else if config.tree[section].type == "table"}
                                            <a href={isPublic ? "/tables/" + config.tree[section].id + "?public" : "/tables/" + config.tree[section].id} class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="View Table">
                                                <i class="svg">{@html grid.md}</i>
                                            </a>
                                        {/if}
                                    </div>
                                </div>
                            </ul>
                        {:else}
                            <Node tooltips={tooltips} mapId={mapId} node={config.tree[section]} isPublic={isPublic} />
                        {/if}
                    {/if}
                {/each}
                {#if config.tree.tables && config.tree.tables.length > 0}
                    <div class="tile tile-centered pr-2 pl-2">
                            <div class="tile-content">
                                    <div class="divider" data-content="TABLES"></div>
                            </div>
                    </div>
                    {#each config.tree.tables as table}
                        <ul class="menu menu-nav">
                            <div class="tile tile-centered">
                                <div class="tile-content tile-tree">
                                        <li class="menu-item">{table.name}</li>
                                </div>
                                <div class="tile-action">
                                    <a href={isPublic ? "/tables/" + table.id + "?public" : "/tables/" + table.id} class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="View Table">
                                        <i class="svg">{@html grid.md}</i>
                                    </a>
                                </div>
                            </div>
                        </ul>
                    {/each}
                {/if}
            {/if}
        {/if}
    </Identity>
</div>

<style>
    #tree {
        position: fixed;
        overflow-y: auto;
        width: 300px;
        height: 100%;
	}
	.accordion .accordion-header {
		cursor: pointer;
		user-select: none;
		height: 1rem;
		padding: 0.2rem 0rem 0.2rem 0.75rem;
	}
	.accordion-body {
		padding-left: 1rem;
        margin: 0.4rem 0 0 0;
	}
	.menu {
        padding: 0 0 0 0.8rem;
    }
    .menu .menu-item {
        padding: 0;
    }
	.menu .menu-item > button {
		border: 0;
	}
	::-webkit-scrollbar {
		width: 6px;
		background-color: #f7f8f9;
	}
	::-webkit-scrollbar-thumb {
		background-color: rgba(122,129,132, 1);
    }
    .menu {
        padding: 0 0 0.8rem 0;
    }
    .menu .menu-item {
        padding: 0;
    }
	.menu-item  > a, .menu .menu-item > button {
        color: #00ab5f;
        border: 0;
        margin: 0;
        padding: 0.4rem 0.8rem;
        text-align: left;
	}
	.menu-item a:hover, .menu-item a:visited {
		background-color: transparent;
	}
	.menu .menu-item > a:focus, .menu .menu-item > a:hover {
		background-color: transparent;
	}
	.menu-item.active {
		color: #00ab5f;
    }
    small.tile-title {
        padding-left: 1.2rem;
    }
    .tile .tile-tree {
        padding-left: 0.8rem;
    }
	.type-icon {
		display: inline-block;
		font-size: 0.8rem;
		height: 1.8rem;
		width: 1.8rem;
		line-height: 1.2rem;
		outline: none;
		padding: 0.4rem 0.4rem;
		text-align: center;
	}
</style>